/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { ModalController, NavController, PopoverController, LoadingController, ToastController, AlertController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';

import { MdlReportesDescargablesPage } from 'src/app/pages/mdl-reportes-descargables/mdl-reportes-descargables.page';
import { MenuMasivosPopoverComponent } from '../menu-masivos-popover/menu-masivos-popover.component';
import { MasivosService } from 'src/app/services/masivos.service';
import { ConexionService } from 'src/app/services/conexion.service';
import { ChatService } from 'src/app/services/chat.service';
import { ValidarToken } from 'src/app/validators/valida-datos';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { FormControl } from '@angular/forms';
import { MasivosPopoverComponent } from '../masivos-popover/masivos-popover.component';
import { Subscription } from 'rxjs';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-header-masivos',
  templateUrl: './header-masivos.component.html',
  styleUrls: ['./header-masivos.component.scss'],
})
export class HeaderMasivosComponent implements OnInit, OnDestroy {

  @Output() cambiarReporteEncuestas = new EventEmitter<boolean>();
  @Output() cambiarReportePlantillas = new EventEmitter<boolean>();
  @Output() cambiarMostrarMasivos = new EventEmitter<boolean>();

  customerAlertOptions = {
    header: 'Selecciona un canal',
    subHeader: 'Canales disponibles',
    translucent: true,
  };

  idAdmin: any;
  idAdminCanal: any;
  idAgente: any;
  classUser: any;

  isListOpen: boolean;
  isPlantillasOpen: boolean;
  mostrarReporteEncuestas = false;
  mostrarReportePlantillas = false;

  masivos: boolean;
  titulo = '';

  mensaje = '';
  estadoConexion = 'online';
  colorConexion = true;

  loading: HTMLIonLoadingElement;
  imagenSeleccionada = 'assets/perfilDefault.png';
  nameSelectCanal: string;
  tipoSelectCanal: any;


  canal: any;
  canales: any;
  selectCanal: any;
  opcionSeleccionada: string;

  isMovile: any;
  wifiIcon: any;
  wifiMessage: any;
  wifiClass: any;
  isOffline: boolean;
  private qualityNetwork: Subscription;
  private lastWifiState: 'green' | 'yellow' | 'red' | null = null;
  private wifiAnimationTimeout: any;
  private activeToast: HTMLIonToastElement | null;

  constructor(
    private whatsapp: WhatsappService,
    public subject: SubjectService,
    public modalController: ModalController,
    public chat: ChatService,
    public alertController: AlertController,
    public loadingController: LoadingController,
    private popoverController: PopoverController,
    private navCtrl: NavController,
    private router: Router,
    private storage: Storage,
    private platform: Platform,
    private masivosService: MasivosService,
    private toastController: ToastController,
    private conexion: ConexionService
  ) {
    this.isListOpen = false;
    this.isPlantillasOpen = false;
    this.canales = [];
    this.opcionSeleccionada = 'campana';
    this.wifiIcon = 'assets/images/wifi_verde.png';
    this.wifiMessage = 'Excelente';
    this.wifiClass = 'greenWifi';
    this.isOffline = false;
    this.activeToast = null;

    this.platform.ready().then(() => {
      this.checkPlatform();
    });

    window.addEventListener('resize', () => {
      this.checkPlatform();
    });
  }

  ngOnInit() {
    this.getCanal();
    this.seeToast();

    this.classUser = new ValidarToken(this.storage);

    this.storage.get('usuario').then((usuario) => {
      // console.log(usuario, 'este es el usuario');
      this.idAdmin = usuario.idAdmin;
      this.idAgente = usuario.idAgente;
      this.idAdminCanal = usuario.idAdminCanal;
    }).then(() => {
      this.mostrarImagen();
      this.getCanales();
      this.calidadRed();
    });

    this.tituloBoton();
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.selectCanal = new FormControl(this.canal.id);
    // console.log(this.canal)
    this.selectCanal = this.canal.id;
    this.nameSelectCanal = this.canal.nombre;
    this.tipoSelectCanal = this.canal.tipo;
  }

  getCanales() {
    this.whatsapp.getCanales(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token).subscribe(
      (data: any) => {  // Usa `any` o define un tipo explícito
        // console.log(data, 'canalesssssss header');
        const { status } = data;
        if (status === 'success') {
          this.canales = data.canales.map(canal => ({
            ...canal,
            numero_id_formateado: this.formatNumber(canal.numero_id)
          }));
        }

      },
      error => {
        console.error(error);
      }
    );
  }

  checkPlatform() {
    if (this.platform.width() >= 600 && this.platform.width() <= 1330) {
      console.log('No es un movil');
      this.isMovile = false;
    } else {
      this.isMovile = true;
      console.log('Es un movil');
    }
  }


  seeToast() {
    this.conexion.estadoConexion$.subscribe(async (estaConectado) => {
      this.estadoConexion = estaConectado ? 'online' : 'offline';
      this.colorConexion = !!estaConectado;

      if (!estaConectado) {
        // OFFLINE → toast fijo si no existe ya
        if (!this.activeToast) {
          const offlineToast = await this.toastController.create({
            message: 'Se ha perdido la conexión a internet',
            duration: 0,
            color: 'danger',
            position: 'bottom',
          });
          this.activeToast = offlineToast;
          await offlineToast.present();

          // limpiar referencia si lo cierran manualmente
          offlineToast.onDidDismiss().then(() => {
            if (this.activeToast === offlineToast) {
              this.activeToast = null;
            }
          });
        }
        this.mensaje = 'Sin Conexión a Internet';
        return;
      }

      // ONLINE → cerrar el toast fijo (si estaba) y luego mostrar “En línea”
      if (this.activeToast) {
        await this.activeToast.dismiss(); // cierra el OFFLINE fijo
        this.activeToast = null;
      }

      const onlineToast = await this.toastController.create({
        message: 'En línea',
        duration: 3000,
        color: 'success',
        position: 'bottom'
      });
      this.activeToast = onlineToast;     // opcional: por consistencia
      await onlineToast.present();
      onlineToast.onDidDismiss().then(() => {
        if (this.activeToast === onlineToast) {
          this.activeToast = null;
        }
      });

      this.mensaje = 'Con Conexión a Internet';
    });
  }

  ngOnDestroy() {
    this.qualityNetwork.unsubscribe();
  }

  calidadRed() {
    this.qualityNetwork = this.subject.redCalidad$.subscribe((quality: any) => {
      const level = quality?.level;
      let state: 'green' | 'yellow' | 'red';

      if (level === 'excellent' || level === 'good' || level === 'ok') {
        this.wifiIcon = 'assets/images/wifi_verde.png';
        this.wifiMessage = 'Buena';
        state = 'green';
      } else if (level === 'high') {
        this.wifiIcon = 'assets/images/wifi_amarillo.png';
        this.wifiMessage = 'Media';
        state = 'yellow';
      } else {
        this.wifiIcon = 'assets/images/wifi_rojo.png';
        this.wifiMessage = 'Mala';
        state = 'red';
      }

      //  Lanza la animación cuando CAMBIA el estado
      if (state !== this.lastWifiState) {
        this.lastWifiState = state;
        this.dispararAnimacionWifi(state);
      }
    });
  }

  cambioCanal(ev) {
    const canalNuevo = this.canales.find((canal) => canal.id === ev.detail.value);
    if (!canalNuevo) { return; }

    this.storage.remove('canal');
    this.storage.set('canal', canalNuevo);
    this.canal = canalNuevo;

    const url = this.router.url;
    const urls = url.includes('masivos-v2') || url.includes('plantillas-masivos') || url.includes('informes-masivos');

    if (urls) {
      this.navCtrl.navigateRoot('/folder/inicio');
      setTimeout(() => {
        window.location.reload();
      }, 90);
      return;
    } else {
      window.location.reload();
    }

    // console.log(canalNuevo, 'canalNuevo')
  }

  formatNumber(numero) {
    const n = numero.replace(/\D/g, '');
    if (n.length === 10) {
      return `(${n.slice(0, 2)}) ${n.slice(2, 5)}-${n.slice(5)}`;
    } else if (n.length === 11) {
      return `(+${n.slice(0, 1)}) ${n.slice(1, 4)}-${n.slice(4)}`;
    }
    return numero;
  }

  ir(ruta) {
    this.navCtrl.navigateForward('/folder/' + ruta)
      .then(() => {
        if (ruta === 'inicio') {
          window.location.reload();
        }
      });

    this.isListOpen = false;
    this.isPlantillasOpen = false;
  }

  irMasivosV2() {
    this.navCtrl.navigateForward('/folder/masivos-v2')
      .then(() => {
        window.location.reload();
      });
    this.masivos = true;
    this.opcionSeleccionada = 'campana';
    // console.log(this.opcionSeleccionada);
  }

  /*  togglePopover() {
      this.isListOpen = !this.isListOpen;
      this.isPlantillasOpen = false;
      this.opcionSeleccionada = 'informes';
      console.log(this.opcionSeleccionada);
    }
  
    togglePlantillas() {
      this.isPlantillasOpen = !this.isPlantillasOpen;
      this.isListOpen = false;
      this.opcionSeleccionada = 'plantillas';
      console.log(this.opcionSeleccionada);
    }*/

  toggleReporteEncuestas() {
    this.masivosService.setMostrarReporteEncuestas(true);
    this.masivosService.setMostrarReportePlantillas(false);
    this.masivosService.setMostrarMasivos(false);
    this.isListOpen = false;
  }

  toggleReportePlantillas() {
    this.masivosService.setMostrarReporteEncuestas(false);
    this.masivosService.setMostrarReportePlantillas(true);
    this.masivosService.setMostrarMasivos(false);
    this.isListOpen = false;
  }

  async modalReportes() {
    const modal = await this.modalController.create({
      component: MdlReportesDescargablesPage,
      cssClass: 'animate__animated animate__slideInRight',
      showBackdrop: false,
      mode: 'ios',
      // backdropDismiss: false,
      componentProps: {
        idAdmin: this.idAdmin,
      },
    });
    this.isListOpen = false;
    return await modal.present();
  }

  tituloBoton() {
    const url = this.router.url;

    if (url === '/folder/masivos-v2') {
      this.titulo = 'Crear Campaña';
    } else if (url === '/folder/plantillas-masivos') {
      this.titulo = 'Plantillas';
    } else if (url === '/folder/informes-masivos') {
      this.titulo = 'Informes';
    }
  }

  async menuMasivosPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: MenuMasivosPopoverComponent,
      event: ev,
      translucent: true,
      mode: 'ios'
    });

    await popover.present();
  }

  async menuPopover(ev: any, menu) {
    const popover = await this.popoverController.create({
      component: MasivosPopoverComponent,
      componentProps: { selectedMenu: menu },
      event: ev,
      translucent: true,
      mode: 'ios',
    });

    this.opcionSeleccionada = menu;
    await popover.present();
  }

  triggerFileInput() {
    const fileInput = document.getElementById('btn-logo-an') as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Dispara el clic del input
    }
  }

  cambiarImagenPerfil(event: any) {
    const archivo = event.target.files[0];
    this.uploadFileMeta(archivo);
  }

  uploadFileMeta(archivo) {
    this.presentLoading('Cargando multimedia');
    const formFile = new FormData();
    formFile.append('file0', archivo);
    formFile.append('file', archivo);

    this.chat.uploadArchivo(formFile, this.classUser.id).subscribe((res: any) => {
      // console.log('uploadArchivo', res);

      if (res.status === 'success') {
        this.loadingController.dismiss();
        this.imagenSeleccionada = res.result.Location;
        this.cambiarFotoPerfil();
      } else {
        this.loadingController.dismiss();
        this.popoverController.dismiss();
        this.presentAlert('Hubo un error', 'no se pudo cargar archivo', 'por favor intenta de nuevo');
      }
    });
  }

  cambiarFotoPerfil() {
    const dataFoto = { foto: this.imagenSeleccionada };

    this.chat.actualizarFotoPerfil(this.idAdmin, this.idAgente, this.classUser.id, this.classUser.rol, this.classUser.token, dataFoto)
      .subscribe((res: any) => {
        // console.log('actualizarFotoPerfil', res);

        if (res.status === 'success') {
          this.loadingController.dismiss();
          this.popoverController.dismiss();
        } else {
          this.loadingController.dismiss();
          this.popoverController.dismiss();
          this.presentAlert('Hubo un error', 'no se pudo cargar archivo', 'por favor intenta de nuevo');
        }
      });
  }

  mostrarImagen() {
    this.chat.getFotoPerfil(this.idAdmin, this.idAgente, this.classUser.id, this.classUser.rol, this.classUser.token)
      .subscribe((res: any) => {
        // console.log('mostrarImagen', res);

        if (res.status === 'succeess') {
          this.imagenSeleccionada = res.foto;
        } else {
          this.imagenSeleccionada = 'assets/perfilDefault.png';
        }
      });
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',

      // message: mensaje,
      cssClass: 'loaderGeneral',
      message: '<ion-img src="../../../assets/images/logoVabelLoading.png"></ion-img>'
    });
    await this.loading.present();
  }

  async presentAlert(header, subheader, mensaje) {
    const alert = await this.alertController.create({
      cssClass: 'animate__animated animate__fadeIn',
      header,
      subHeader: subheader,
      message: mensaje,
      buttons: ['OK'],
    });

    await alert.present();
  }

  seleccionarOpcion(opcion: string) {
    this.opcionSeleccionada = opcion;
  }

  private dispararAnimacionWifi(state: 'green' | 'yellow' | 'red') {
    // Si había una animación en curso, la limpiamos
    if (this.wifiAnimationTimeout) {
      clearTimeout(this.wifiAnimationTimeout);
    }

    // Asignar la clase que dispara el @keyframes
    if (state === 'green') {
      this.wifiClass = 'greenWifi';
    } else if (state === 'yellow') {
      this.wifiClass = 'yellowWifi';
    } else {
      this.wifiClass = 'redWifi';
    }

    // Quitar la clase cuando termine el pulse
    this.wifiAnimationTimeout = setTimeout(() => {
      this.wifiClass = '';
    }, 1800); // mismo tiempo que el animation del SCSS
  }
}
